import { useQuery } from '@tanstack/react-query';
import { HTTPError } from 'ky';
import { useSession } from 'next-auth/react';
import { ShopTypes } from '~/lib/data-contract';
import useUserProfile from '~/services/shop/hooks/mit-fog/useUserProfile';
import { getMyOrders } from '../../operations/mit-fog';

export default function useMyOrders() {
    const { data: profile } = useUserProfile();
    const { data } = useSession();
    const token = data?.accessToken ?? null;
    const customerId = profile?.customer?.id ?? null;

    return useQuery<ShopTypes.OrderHeader[], HTTPError | Error>(
        ['myOrders', { customerId, token }],
        ({ signal }) => getMyOrders({ signal, customerId, token }),
        {
            enabled: Boolean(data?.accessToken),
        },
    );
}
